import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  Crop: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.EDIT_CROP_SUCCESS:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}
